/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';

import {
	Slider
} from '@ba/ba-ui-carbon-toolkit';

export default class RgbSlider extends PureComponent{

	static propTypes = {
		color: PropTypes.string,
		onChange: PropTypes.func,
		selectedColorType: PropTypes.string,
		value: PropTypes.int
	}

	render(){
		let sliderId = 'id' + (this.props.color.charAt(0).toUpperCase() + this.props.color.slice(1)) + 'Range';
		let max = this.props.selectedColorType == 'RGB' ? 255 : (this.props.color == 'Hue' ? 360 : 100);

		return (
			<div className='clsRgbWrapper'>
				<Slider
					light
					id={sliderId}
					showBoundaryLabels
					value={this.props.value}
					labelText={StringResources.get('code'.concat(this.props.color))}
					onChange={(value) => this.props.onChange(parseInt(value), this.props.color)}
					min={0}
					max={max}
					hideTextInput={false}
					className='clsRgbSlider'
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/RgbSlider.js